import swal from 'sweetalert2';


const formatDate = (isoString) => {
  if(!isoString)
    return '';
  const date = new Date(isoString);
  // Convert to a readable format 
  let langFormat = 'en-US'
  // if(localStorage.getItem('language') && localStorage.getItem('language') != 'en')
  //   langFormat = 'ar-EG'
  const parts = date.toLocaleString(langFormat, {
    year: 'numeric',
    // month: 'long',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true, 
  });

  const [mdy, time] = parts.split(', ');
  const [month, day, year] = mdy.split('/');
  const formatted = `${year}-${month}-${day} ${time}`;
  return formatted;
}


const shortDate = (date) => {
  if(!date)
    return '';
  return new Date(date).toISOString().split("T")[0];
}


const toast = (msg, icon='error') => {
  const Toast = swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = swal.stopTimer;
      toast.onmouseleave = swal.resumeTimer;
    }
  });
  Toast.fire({
    icon: icon,
    title: msg,
  });
}


const loaderToast = (title, width=70, time=2000) => {
  swal.fire({
    title: title,
    html: `<div class="text-center">
      <img src="/assets/images/subloader.gif" style="width: ${width}px;" alt="">
    </div>`,
    timer: time,
    timerProgressBar: true,
    showConfirmButton: false,
    didOpen: () => {
      // swal.showLoading();
    },
    willClose: () => {
      // clearInterval(timerInterval);
    }
  });
}


export {
  formatDate, shortDate, toast, loaderToast
}
